var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"root",class:{textarea: _vm.textarea}},[_c('div',{staticClass:"label",class:{hasValue: _vm.hasValue}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.computedValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }